import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { ErrorFace } from "@/components/ErrorFace";
import { Flex, Header, Text } from "@/eworkitComponents";
import { RouteButton } from "@/infrastructure/Route";
import { AnimatedLayoutContainer } from "@/views/components/Layout";
import { router } from "@/views/router";

export const PasswordResetTokenInvalid: FC = memo(() => {
  const { t } = useTranslation(["public", "common"]);
  return (
    <AnimatedLayoutContainer>
      <Flex margin={["xl"]} innerMargin="md" direction="column" align="center">
        <ErrorFace color="danger" />
        <Header size="sm" align="center">
          {t("SESSION_PASSWORD_SETUP.TOKEN_EXPIRED_MESSAGE")}
        </Header>
        <div>
          <Flex margin={["xl", false, false, false]} direction="column" innerMargin="md">
            <RouteButton
              variant="primary"
              path={router.get("password-reset").path}
              testName={router.get("password-reset").name}
              size="lg">
              <Text uppercase>{t("SESSION_PASSWORD_RESET.BUTTON_RESET")}</Text>
            </RouteButton>
          </Flex>
        </div>
      </Flex>
    </AnimatedLayoutContainer>
  );
});
